import React, { useState } from 'react';
import AccurityPaper from '../../paper/components/AccurityPaper';
import Resizer from '../../resizer/components/Resizer';
import ProgressIndicator from '../../progressIndicator/components/ProgressIndicator';
var DEFAULT_DETAIL_WIDTH = 440;
var AccurityDetail = function (_a) {
    var width = _a.width, setWidth = _a.setWidth, onStopResize = _a.onStopResize, minWidth = _a.minWidth, maxWidth = _a.maxWidth, showProgressIndicator = _a.showProgressIndicator, inverted = _a.inverted, children = _a.children;
    var _b = useState(minWidth || DEFAULT_DETAIL_WIDTH), uncontrolledWidth = _b[0], setUncontrolledWidth = _b[1]; // only used if width state not passed from above
    var detailWidth = width !== null && width !== void 0 ? width : uncontrolledWidth;
    var isResizeable = minWidth !== maxWidth;
    var handleResize = function (deltaValue) {
        var newWidth = detailWidth + deltaValue;
        if (setWidth !== undefined) {
            setWidth(newWidth);
        }
        else {
            setUncontrolledWidth(newWidth);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AccurityPaper, { sx: {
                width: detailWidth + 'px',
                backgroundColor: inverted ? 'background.inverted' : undefined,
                color: inverted ? 'text.inverted' : undefined,
            }, className: "accurityDetail__container" },
            showProgressIndicator && React.createElement(ProgressIndicator, { className: "accurityDetail__progressIndicator" }),
            children),
        isResizeable &&
            React.createElement(Resizer, { value: detailWidth, onResize: handleResize, onStopResize: onStopResize, min: minWidth, max: maxWidth, displayDefaultResizeHandle: true })));
};
export default AccurityDetail;
//# sourceMappingURL=AccurityDetail.js.map